export enum IHostsListPageTabs {
  HostsList = 'list',
  ResourceUtilization = 'resource-utilization',
  // FR-007: New tab for aggregated VMHA events
  VMHAEvents = 'vmha-events',
}

export const searchTargets = [
  'name',
  'id',
  'interfaces',
  'clusterName',
  'roleStatuses',
  'responding',
  'schedulingStatus',
]
